<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M13,2C13,2,9,2,9,2C9,2,9,1,9,1C9,0.45,8.55,0,8,0C7.45,0,7,0.45,7,1C7,1,7,2,7,2C7,2,3,2,3,2C2.45,2,2,2.45,2,3C2,3,2,6,2,6C2,6.55,2.45,7,3,7C3,7,7,7,7,7C7,7,7,9,7,9C7,9,6,9,6,9C5.45,9,5,9.45,5,10C5,10,5,13,5,13C5,13.55,5.45,14,6,14C6,14,7,14,7,14C7,14,7,15,7,15C7,15.55,7.45,16,8,16C8.55,16,9,15.55,9,15C9,15,9,14,9,14C9,14,10,14,10,14C10.55,14,11,13.55,11,13C11,13,11,10,11,10C11,9.45,10.55,9,10,9C10,9,9,9,9,9C9,9,9,7,9,7C9,7,13,7,13,7C13.55,7,14,6.55,14,6C14,6,14,3,14,3C14,2.45,13.55,2,13,2C13,2,13,2,13,2Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'AlignmentVerticalCenter',
} as DefineComponent
</script>
